module.exports = __webpack_public_path__ + "img/12.605fc7df.jpg";